import React from "react";
import { ClipboardCopy, Trophy } from "lucide-react";
import { copyText, requestText } from "@/components/QuickRequest";
import { eur, itDate } from "@/lib/pa";

const STATUS = {
  pending: ["In attesa", "bg-slate-100 text-slate-600"],
  available: ["Disponibile", "bg-emerald-100 text-emerald-800"],
  unavailable: ["Non disponibile", "bg-red-50 text-red-700"],
};

export const groupByBatch = (items) => {
  const m = new Map();
  items.forEach((r) => { const k = r.batchId || r.id; m.set(k, [...(m.get(k) || []), r]); });
  return [...m.entries()];
};

export function MepaCompare({ batchId, rows }) {
  const first = rows[0];
  const avail = rows.filter((r) => r.status === "available");
  const best = avail.length ? avail.reduce((a, b) => (a.mepa.amounts.totalGross <= b.mepa.amounts.totalGross ? a : b)).id : null;
  const sorted = [...rows].sort((a, b) => (a.status === "available" ? 0 : a.status === "pending" ? 1 : 2) - (b.status === "available" ? 0 : b.status === "pending" ? 1 : 2) || a.mepa.amounts.totalGross - b.mepa.amounts.totalGross);
  return (
    <div className="border border-gold/50 rounded-2xl p-4 space-y-3" data-testid={`mepa-compare-${batchId}`}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="overline text-gold">Confronto risposte · {rows.length} operatori</div>
          <div className="text-sm text-navy font-semibold">{first.eventType} · {itDate(first.eventDate)} · {first.eventLocation}</div>
        </div>
        <span className="text-xs text-slate-500" data-testid={`mepa-compare-summary-${batchId}`}>{avail.length} disponibili · {rows.filter((r) => r.status === "pending").length} in attesa</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="text-left text-xs text-slate-500 border-b border-slate-200">
            <th className="py-2 pr-3">Operatore</th><th className="py-2 pr-3">Disponibilità</th><th className="py-2 pr-3 text-right">Imponibile</th>
            <th className="py-2 pr-3 text-right">IVA</th><th className="py-2 pr-3 text-right">Totale</th><th className="py-2"></th>
          </tr></thead>
          <tbody>
            {sorted.map((r) => {
              const a = r.mepa.amounts;
              const [label, cls] = STATUS[r.status];
              return (
                <tr key={r.id} className={`border-b border-slate-100 align-top ${r.id === best ? "bg-gold/10" : ""}`} data-testid={`mepa-compare-row-${r.id}`}>
                  <td className="py-2.5 pr-3">
                    <div className="font-semibold text-navy flex items-center gap-1.5">{r.operatorName}{r.id === best && <span data-testid={`mepa-compare-best-${r.id}`} className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-gold text-navy"><Trophy className="w-3 h-3"/>Migliore offerta</span>}</div>
                    <div className="text-xs text-slate-500">CPV {r.mepa.cpv.map((c) => c.code).join(", ")} · {r.distanceKm} km</div>
                    {r.replyNote && <div className="text-xs text-slate-600 mt-1 border-l-2 border-gold pl-2">{r.replyNote}</div>}
                  </td>
                  <td className="py-2.5 pr-3"><span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${cls}`} data-testid={`mepa-compare-status-${r.id}`}>{label}</span></td>
                  <td className="py-2.5 pr-3 text-right whitespace-nowrap">{eur(a.subtotalNet)}</td>
                  <td className="py-2.5 pr-3 text-right text-xs whitespace-nowrap">{a.vatLabel}<br/>{eur(a.vat)}{a.splitPayment && <div className="text-[10px] text-gold">all'Erario (split)</div>}</td>
                  <td className="py-2.5 pr-3 text-right font-bold whitespace-nowrap" data-testid={`mepa-compare-total-${r.id}`}>{eur(a.totalGross)}</td>
                  <td className="py-2.5"><button type="button" data-testid={`mepa-request-copy-${r.id}`} onClick={() => copyText(requestText(r))} title="Copia dati Trattativa Diretta" className="p-2 rounded-full border border-slate-300 hover:border-gold"><ClipboardCopy className="w-4 h-4"/></button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-slate-500 sm:hidden">Scorri la tabella di lato per vedere tutti i prezzi.</p>
      <p className="text-[11px] text-slate-500">Prezzi indicativi calcolati da compenso base + trasferta (0,40 €/km). "Migliore offerta" = totale più basso tra gli operatori disponibili.</p>
    </div>
  );
}
